<div id="header-menu-container" class="d-flex justify-content-center align-items-center header-menu-container">
  <!-- MAPA -->
  <div class="col-auto mx-4 menu-link" #link routerLink="/map" routerLinkActive="active-link" *appCan="'map:read'">
    <div></div>
    <p>Mapa</p>
    <div class="bottom-border" #border></div>
  </div>

  <!-- GESTÃO -->
  <ng-container *ngIf="
      authorizationService.checkLicenseType(licenseTypeEnum.Full)
    ">
    <div class="col-auto mx-4 menu-link" #link [routerLink]="router" routerLinkActive="active-link" *appCan="'projects|regions|areas|routes|paths|stock:read'">
      <div></div>
      <p>Gestão</p>
      <div class="bottom-border" #border></div>
    </div>
  </ng-container>

  <!-- CATÁLOGO -->
  <div class="col-auto mx-4 menu-link" #link routerLink="/catalog" routerLinkActive="active-link"
    *appCan="'catalog:read'">
    <div></div>
    <p>Catálogo</p>
    <div class="bottom-border" #border></div>
  </div>

  <!-- SERVIÇOS -->
  <ng-container *ngIf="
      authorizationService.checkLicenseType(licenseTypeEnum.Full)
    ">
    <div class="col-auto mx-4 menu-link" #link routerLink="/services" routerLinkActive="active-link"
      *appCan="'services:read'">
      <div></div>
      <p>Serviços</p>
      <div class="bottom-border" #border></div>
    </div>
  </ng-container>

  <!-- RELATÓRIOS -->
  <ng-container>
    <div class="col-auto mx-4 menu-link" #link routerLink="/report" routerLinkActive="active-link"
      *appCan="'reports:read'">
      <div></div>
      <p>Relatórios</p>
      <div class="bottom-border" #border></div>
    </div>
  </ng-container>

  <!-- DASHBOARD -->
  <ng-container>
    <div class="col-auto mx-4 menu-link" #link routerLink="/dashboard" routerLinkActive="active-link"
      *appCan="'dashboard:read'">
      <div></div>
      <p>Dashboard</p>
      <div class="bottom-border" #border></div>
    </div>
  </ng-container>
</div>